export const dashboardOverviewData = {
  revenue: {
    amount: "RS128,540",
    trend: "12.5%",
    period: "Last 30 days",
    comparisonLabel: "Compared to previous period",
  },
  instructors: {
    label: "Total verified instructors",
    color: "#923D8C",
    pendingColor: "#F1C841",
    ctaText: "Verify Instructors",
  },
  studentMetrics: {
    activeStudents: "3,842",
    newRegistrations: "+127",
    weeklyTrend: "8.2% this week",
    engagementRate: 78,
    bars: [58, 86, 72, 81, 102, 91, 106, 92],
  },
};

export const calculateInstructorMetrics = (verified, unverified) => {
  const verifiedCount = Number(verified) || 0;
  const unverifiedCount = Number(unverified) || 0;
  const total = verifiedCount + unverifiedCount;
  const verificationPercentage =
    total > 0 ? Math.round((verifiedCount / total) * 100) : 0;

  return {
    verifiedInstructors: {
      completion: verificationPercentage,
      count: verifiedCount,
      label: dashboardOverviewData.instructors.label,
      color: dashboardOverviewData.instructors.color,
    },
    pendingVerification: {
      completion: total > 0 ? 100 - verificationPercentage : 0,
      count: unverifiedCount,
      cta: dashboardOverviewData.instructors.ctaText,
      color: dashboardOverviewData.instructors.pendingColor,
    },
  };
};

export const sessions = [
  {
    id: 1,
    time: "09:00 - 10:30",
    course: "Advanced JavaScript",
    instructor: {
      name: "Rimsha Latif",
      initials: "RL",
      color: "#0EA5E9",
    },
    session: "2 of 12",
    status: "Upcoming",
  },
  {
    id: 2,
    time: "11:00 - 12:30",
    course: "UI/UX Design Principles",
    instructor: {
      name: "Rimsha Latif",
      initials: "RL",
      color: "#14B8A6",
    },
    session: "2 of 12",
    status: "Upcoming",
  },
  {
    id: 3,
    time: "14:00 - 15:30",
    course: "Data Science Fundamentals",
    instructor: {
      name: "Rimsha Latif",
      initials: "RL",
      color: "#64748B",
    },
    session: "2 of 12",
    status: "Upcoming",
  },
  {
    id: 4,
    time: "16:00 - 17:30",
    course: "Digital Marketing Strategy",
    instructor: {
      name: "Rimsha Latif",
      initials: "RL",
      color: "#F97316",
    },
    session: "2 of 12",
    status: "Upcoming",
  },
];

export const dashboardAnalyticsData = {
  sectionTitle: "AI-Powered Analytics",
  courses: {
    title: "Course Popularity",
    bars: [52, 84, 65, 33, 96],
    labels: ["Web Dev", "UI/UX", "AI/ML"],
    mostPopular: "Web Development",
    trending: "AI & Machine Learning",
  },
  instructors: {
    title: "Instructor Performance",
    bars: [96, 88, 80, 91, 62],
    labels: ["Emily J", "Emily J", "Emily J", "Emily J", "Emily J"],
    barColors: [
      "bg-[#82C5BD]",
      "bg-[#25CEB3]",
      "bg-[#F2BB6A]",
      "bg-[#4BD17B]",
      "bg-[#F48A61]",
    ],
    topRated: "Emily Johnson (4.9)",
    needsImprovement: "David Miller (3.2)",
  },
  engagement: {
    title: "Student Engagement",
    points: [78, 92, 82, 66, 58, 73, 95],
    labels: ["Web Dev", "UI/UX", "AI/ML"],
    mostEngaged: "Data Science (92)",
    leastEngaged: "Marketing (67)",
  },
};

